import { W2UiCmd } from "./w2const";

export interface Search {
  type: string;
  field: string;
  operator: string;
  values: any;
}

export interface Sort {
  field: string;
  direction: string;
}

export interface Edit {
  [key: string]: any;
}

const enc = encodeURIComponent;
const encs = (x: string | number | boolean) => typeof x === "string" ? encodeURIComponent(x) : x;
//const enc = (x: any) => x;

class W2UiFilter {
  constructor(
    public cmd: string = W2UiCmd.GET_RECORDS,
    public limit?: number,
    public offset?: number,
    public selected?: string,
    public searchLogic: string = "AND",
    public search?: Search[],
    public sort?: Sort[],
    public edit?: Edit[],
    public del?: number[]
  ) {}

  get params() {
    return [
      ...this.prepareCmd(),
      ...this.prepareLimit(),
      ...this.prepareOffset(),
      ...this.prepareSelected(),
      ...this.prepareSearchLogic(),
      ...this.prepareSearchParams(),
      ...this.prepareSortParams(),
      ...this.prepareEditParams(),
      ...this.prepareDeleteParams(),
    ];
  }

  get stringParams() {
    return this.params.join("&");
  }

  prepareCmd() {
    return [`cmd=${enc(this.cmd)}`];
  }

  prepareLimit() {
    return this.limit ? [`limit=${enc(this.limit)}`] : [];
  }

  prepareOffset() {
    return this.offset ? [`offset=${enc(this.offset)}`] : [];
  }

  prepareSelected() {
    return this.selected ? [`selected=${enc(this.selected)}`] : [];
  }

  prepareSearchLogic() {
    return this.searchLogic ? [`searchLogic=${enc(this.searchLogic)}`] : [];
  }

  prepareSearchParams() {
    const params = [];

    if (this.search) {
      for (let i = 0; i < this.search.length; i++) {
        params.push(`search[${i}][type]=${enc(this.search[i].type)}`);
        params.push(`search[${i}][field]=${enc(this.search[i].field)}`);
        params.push(`search[${i}][operator]=${enc(this.search[i].operator)}`);

        if (
          Object.prototype.toString.call(this.search[i].values) ===
          "[object Array]"
        ) {
          for (const value of this.search[i].values) {
            params.push(`search[${i}][value][]=${enc(value)}`);
          }
        } else {
          params.push(`search[${i}][value]=${enc(this.search[i].values)}`);
        }
      }
    }

    return params;
  }

  prepareEditParams() {
    const params = [];

    if (this.edit) {
      for (let i = 0; i < this.edit.length; i++) {
        for (const [k, v] of Object.entries(this.edit[i])) {
          params.push(`changes[${i}][${k}]=${encs(v)}`);
        }
      }
    }

    return params;
  }

  prepareDeleteParams() {
    const params = [];

    if (this.del) {
      for (const i in this.del) {
        params.push(`selected[${i}]=${enc(this.del[i])}`);
      }
    }

    return params;
  }

  prepareSortParams() {
    const params = [];

    if (this.sort) {
      for (let i = 0; i < this.sort.length; i++) {
        params.push(`sort[${i}][field]=${enc(this.sort[i].field)}`);
        params.push(`sort[${i}][direction]=${enc(this.sort[i].direction)}`);
      }
    }

    return params;
  }
}

export default W2UiFilter;
